import { ID_OPPOSITION } from 'civil-status/components/step/form/last-step/accordions/section/list/list-opposition';
import { PublicationVM, ParentVM, SectionVM } from 'civil-status/view-models/step-form';
import { CodeTypeAct } from './code-type-act';
import { IdResidence } from './id-residence';
import { CodeExtremesDecree } from './code-extremes-decree';

export const initialConditionsItem = {
  id: '0',
  value: 'Nulla da segnalare',
};

export const initialFilterPublication: PublicationVM = {
  year: '',
  number: '',
  part: '',
  register: '',
  serie: '',
  yearSurname: '',
  surnameGroom: '',
  surnameWife: '',
  date: null,
  time: null,
  reducedDay: 0,
  residence: '',
  state: '',
  response: undefined,
};

export const initialValuesSections: SectionVM = {
  isSaved: false,
  isDatePresumed: false,
  datePresumedStart: null,
  datePresumedEnd: null,
  notePresumed: '',
  // per data certa
  dateDeath: null,
  timeDeath: null,
  // italian form
  italian: {
    disabledMunicipality: false,
    municipality: undefined,
  },
  disabledRegister: false,
  placeDeath: '',
  otherPlaceDeath: '',
  address: '',
  conditionsItem: initialConditionsItem,
  isWithInterprete: false,
  numberAppearing: '',
  authority: undefined,
  otherAuthority: '',
  dateCommunication: null,
  typeCommunication: undefined,
  dateConferralDecree: null,
  dateNotificationDecree: null,
  extremesDecree: '',
  isInterestedPresent: false,
  dateRegistrationCourt: null,
  reasonImpediment: undefined,
  actComposition: undefined,
  actForm: {
    dateAct: null,
    idAnsc: '',
    italian: {
      disabledMunicipality: false,
      municipality: undefined,
    },
    municipalNumber: '',
    portion: '',
    presentationDocument: '',
    register: '',
    disabledRegister: false,
    serie: '',
    typeEvent: '',
    year: '',
    volume: '',
  },
  applicant: undefined,
  authorityPostAddress: undefined,
  certificateDate: undefined,
  certificateReleaseFrom: undefined,
  conceivedMonth: undefined,
  dateTranscription: undefined,
  descriptionBirthPlace: undefined,
  descriptionsReasonRecovery: undefined,
  documentDateFormation: undefined,
  documentDescription: undefined,
  documentExtremes: undefined,
  documentRequestDate: undefined,
  effectiveDate: undefined,
  effectiveTime: undefined,
  foreign: undefined,
  hiringTiming: undefined,
  isForeign: undefined,
  nameInstitution: undefined,
  reasonLossCitizenship: undefined,
  typeRequest: undefined,
  typeBirthPlace: undefined,
  typeResidence: undefined,
  typeService: undefined,
  nationEmployment: undefined,
  typeAct: CodeTypeAct.attoCartaceo,
  reasonRecovery: undefined,
  typologyConsent: undefined,
  typeDeclaration: undefined,
  annotations: [],
  opposition: ID_OPPOSITION.ID_NESSUNA,
  ageDefect: '1',
  relationship: '0',
  genericImpediment: '0',
  typeActToTranscribed: '1',
  filterPublication: initialFilterPublication,
  publicationData: initialFilterPublication,
  ufcDelegate: '',
  isReceivedByPost: false,
  numberLawCitizenship: '',
  number: '',
  emergencyRegister: undefined,
  margin: '',
  typeExtremesDecree: CodeExtremesDecree.Normale,
};

export const initialValuesParent: ParentVM = {
  isFromSearchPerson: false,
  searchPerson: undefined,
  generality: {
    name: '',
    surname: '',
    birthDate: null,
    attorney: '',
    birthTime: null,
    gender: '',
    fiscalCode: '',
    isForeignBorn: false,
    foreign: {
      state: null,
      municipality: null,
    },
    italian: {
      municipality: null,
    },
    typeResidence: IdResidence.Italian,
    foreignResidence: {
      state: null,
      municipality: null,
    },
    italianResidence: {
      municipality: null,
    },
    clarificationSurname: '',
    rolo: '',
    address: '',
    descriptionBirthPlace: '',
    reasonDelay: '',
    birthPlaceItem: undefined,
    civilStatusItem: undefined,
    codeIstat: undefined,
    conditionsItem: initialConditionsItem,
    conditionsItemSignatory: initialConditionsItem,
    idAnpr: undefined,
    idAnsc: '',
    idSubject: undefined,
    isWithInterprete: undefined,
    nationality: undefined,
    reasonImpediment: undefined,
    surnameItem: undefined,
    verificationTypeItem: undefined,
    allTwins: undefined,
    isWithTwins: false,
    necropsyDate: null,
    bornTypology: '',
    dateCommunication: null,
    dateStartResidence: null,
    documentExpiryDate: null,
    isChangeSurnameName: false,
    typeAct: CodeTypeAct.attoCartaceo,
  },
};
